import { cnMessageBar } from '../MessageBar.classname';
export var registryId = cnMessageBar();
